//#region applyMasks.  This setups up all the default masks for the entire page

function applyMasks() {
    $(".numericMask").inputmask("numeric");
    $(".dateMask").inputmask("mm/dd/yyyy");
}

//#endregion